import Drawer from 'antd/lib/drawer';

export default Drawer;
